import {
    extraErrorDataIntegration,
    handleErrorWithSentry,
    replayIntegration,
} from "@sentry/sveltekit"
import * as Sentry from "@sentry/sveltekit"
import { version } from "$app/environment"
import { PUBLIC_ENV } from "$env/static/public"

const isAutomated = typeof navigator !== "undefined" && navigator.webdriver === true

Sentry.init({
    dsn: "https://8b8e08316a81faa10e4967a195a799a0@o4507685475123200.ingest.de.sentry.io/4508239565094993",
    tracesSampleRate: 0.1,
    // This sets the sample rate to be 10%. You may want this to be 100% while
    // in development and sample at a lower rate in production
    replaysSessionSampleRate: 0.1,

    // If the entire session is not sampled, use the below sample rate to sample
    // sessions when an error occurs.
    replaysOnErrorSampleRate: 1.0,

    // If you don't want to use Session Replay, just remove the line below:
    integrations: [
        replayIntegration({
            networkDetailAllowUrls: [/https:\/\/.*\.satellitevu\.com\/.*/],
            networkCaptureBodies: true,
            maskAllText: false,
            blockAllMedia: false,
            maskAllInputs: false,
        }),
        extraErrorDataIntegration({ depth: 3 }),
    ],
    environment: PUBLIC_ENV,
    release: version,
    enabled: PUBLIC_ENV !== "local" && PUBLIC_ENV !== "preview" && !isAutomated,
    ignoreErrors: [
        /^Login required$/,
        "TypeError: Failed to fetch",
        "TypeError: NetworkError when attempting to fetch resource.",
        /Importing a module script failed|Failed to fetch dynamically imported module|error loading dynamically imported module/,
    ],
})

window.addEventListener("vite:preloadError", (event) => {
    event.preventDefault()
    const reloads = Number(sessionStorage.getItem("preloadReloads") ?? 0)
    if (reloads < 2) {
        sessionStorage.setItem("preloadReloads", String(reloads + 1))
        window.location.reload()
    }
})

window.addEventListener("load", () => {
    sessionStorage.removeItem("preloadReloads")
})

const MODULE_FETCH_ERROR =
    /Importing a module script failed|Failed to fetch dynamically imported module|error loading dynamically imported module/

const isAbortError = (error: unknown) =>
    error instanceof DOMException && error.name === "AbortError"

export const handleError = handleErrorWithSentry(({ error }: { error: unknown }) => {
    if (isAbortError(error)) return
    if (error instanceof TypeError && MODULE_FETCH_ERROR.test(error.message)) {
        window.location.reload()
    }
})
